import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

import { School } from '../Models/index';

@Injectable()
export class SchoolService {

  private headers = new Headers({'Content-Type': 'application/json'});
  private schoolsUrl = 'api/schools';  // URL to web api

  constructor(private http: Http) { }

  // // Get school information by school id
  // getById(id: number) {
  //   return this.http.get(this.schoolsUrl + id, {headers: this.headers})
  //       .map((response: Response) => response.json());
  // }

  // Add a new school
  create(school: School) {
    return this.http.post(this.schoolsUrl, school, {headers: this.headers})
        .map((response: Response) => response.json());
  }

}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/Service/school.service.ts